import React from 'react';
import styled from 'styled-components';
import rightArrowIcon from 'images/circle_right_arrow-40x40.png';

import { useSelector } from 'react-redux';
export default function SurveyIntro({onComplete}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  let handleNext = (e) => {
    if(onComplete)
    {
      onComplete();
    }
  }
  return (
    <SurveyWrapper>
      <TitleWrapper>
        <TitleTxt>나와 같이할 친구 구해요</TitleTxt> <TitleBeta>Beta</TitleBeta>
      </TitleWrapper>
      <BodyWrapper>
        <div>
          <IntroTxt>
            같이 자기계발 할 친구를 구하시나요?<br />
            {userInfo['name']} 님과 성향, 목표가 맞는 친구를 <br />
            추천해드릴게요!
          </IntroTxt>
        </div>
        <div>
          <NextBtn onClick={handleNext}>
            <img src={rightArrowIcon} alt={'show next step button'}/>
          </NextBtn>
        </div>
      </BodyWrapper>
    </SurveyWrapper>
  );
}
const SurveyWrapper = styled.div`
  padding: calc(100vw * (17.5 / 375)) calc(100vw * (17 / 375)) 0;
`;
const TitleWrapper = styled.div`
  margin-bottom:calc(100vw * (31 / 375));
`;
const TitleTxt = styled.span`
  font-weight: bold;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;
`;
const TitleBeta = styled.span`
  font-family: Arial;
  font-style: italic;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (14 / 375));
  color: #707070;
`;
const BodyWrapper = styled.div`
  background: #F7F7F7;
  border-radius: 10px;
  padding: calc(100vw * (23 / 375)) calc(100vw * (19 / 375));
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const IntroTxt = styled.p`
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  color: #4E4E4E;
  line-height: 1.6;
`
const NextBtn = styled.span`
  width: calc(100vw * (40 / 375));
  height: calc(100vw * (40 / 375));
  display: inline-block;
`;